import React from 'react';
import { GridComponent, ColumnsDirective as GridColumnsDirective, ColumnDirective as GridColumnDirective } from '@syncfusion/ej2-react-grids';

declare var InovxLoader: any;

export interface FormFieldsSectionProps {
    sortedAttributeDefinitions: IAttributeDefinition[];
    attributeDataTypeLabels: { [key: number]: string };
    onAddAttribute: () => void;
    onEditAttribute: (id: string) => void;
    onDeleteAttribute: (id: string) => void;
}

const FormFieldsSection: React.FC<FormFieldsSectionProps> = ({ sortedAttributeDefinitions, attributeDataTypeLabels, onAddAttribute, onEditAttribute, onDeleteAttribute }) => {
    const [tableHeight, setTableHeight] = React.useState(window.innerHeight - 460);
    //make tableHeight responsive to window resize
    React.useEffect(() => {
        const handleResize = () => {
            let newTableHeight = window.innerHeight - 460;
            if(window.innerWidth < 1200){
                newTableHeight = window.innerHeight - 200;
            }
            if (newTableHeight !== tableHeight) {
                // Force update to re-render the component with the new table height
                if(newTableHeight < 200){
                    newTableHeight = 200;
                }
                setTableHeight(newTableHeight);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [tableHeight]);
    
    return (
        <div className="configuration-form-tab-pane">
            <div className="row d-flex">
                <div className="col-md-12 p-2">
                    <div className="d-flex a-ic" style={{ alignItems: 'center', width: '100%' }}>
                        <div className="ctm-control-label">
                            <button type="button" className="configuration-form-add-primary-btn plus-btn" onClick={onAddAttribute} title={InovxLoader.t('facility:form.addAttributeTitle')}>
                                <span className="plus-btn-icon"><i className="fa fa-plus" /></span> <div className="configuration-form-panel-title">{InovxLoader.t('facility:form.addAttributeTitle')}</div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row d-flex">
                <div className="col-md-12">
                    <div className="configuration-grid responsive-grid">
                        <GridComponent
                            dataSource={sortedAttributeDefinitions}
                            height={tableHeight}
                            allowPaging={false}
                            allowSorting={false}
                            allowSelection={false}
                            emptyRecordTemplate={InovxLoader.t('facility:message.noAttributes')}
                        >
                            <GridColumnsDirective>
                                <GridColumnDirective field="Name" headerText={InovxLoader.t('facility:form.attributeName')} width="220" textAlign="Left" />
                                <GridColumnDirective
                                    field="DataType"
                                    headerText={InovxLoader.t('facility:form.dataType')}
                                    width="180"
                                    textAlign="Left"
                                    template={(props: any) => attributeDataTypeLabels[props.DataType]}
                                />
                                <GridColumnDirective headerText="." width="80" textAlign="Center" template={(props: IAttributeDefinition) => (
                                    <span>
                                        <i className="fa fa-pencil" style={{ cursor: 'pointer', fontSize: '1.4em', color: '#337ab7', marginRight: 16 }} title={InovxLoader.t('facility:preferences.editButton')} onClick={() => onEditAttribute(props.ID)}></i>
                                        <i className="fa fa-trash" style={{ cursor: 'pointer', fontSize: '1.4em', color: '#337ab7' }} title={InovxLoader.t('facility:form.delete')} onClick={() => onDeleteAttribute(props.ID)}></i>
                                    </span>
                                )} />
                            </GridColumnsDirective>
                        </GridComponent>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormFieldsSection;